import {observer} from 'mobx-react-lite'
import React from 'react'
import {useStickerStore} from '@components/sticker/sticker-store'
import {StickerMenuTextPanel} from './sticker-menu-text-panel'
import {StickerMenuTextTask} from './sticker-menu-text-task'

export const StickerTextMenu = observer(() => {
  const [, store] = useStickerStore()

  if (store.stickerData.location === 'panel') {
    return <StickerMenuTextPanel />
  }
  if (store.stickerData.location === 'task') {
    return <StickerMenuTextTask />
  }
  return <></>
})
